import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import PublicTestimonialSection from '../../components/testimonial/PublicTestimonialSection';
import TestimonialAPIConnectors from '../../api/TestimonialAPIConnectors';

class PublicTestimonialContainer extends Component {
  static propTypes = {
    showAll: PropTypes.bool,
  };

  static defaultProps = {
    showAll: true,
  };

  componentDidMount() {
    const { actions } = this.props;

    // Fetch testimonials
    actions.fetchTestimonialRequest();
    TestimonialAPIConnectors.getTestimonials()
      .then(data => actions.fetchTestimonialSuccess(data))
      .catch(() => {
        actions.fetchTestimonialFailure();
      });
  }

  getPhotoDownloadURLCallback = (url) => {
    const {
      actions: {
        getPhotoDownloadURL,
      },
    } = this.props;
    return getPhotoDownloadURL(url);
  }

  // NOTE: We need to get the actual MedicalGroup model from store, which means "metadata",
  // by using "medicalGroupId" field in the User model.
  render() {
    const {
      showAll,
      router,
      reducers: {
        testimonial,
        metadata,
      },
    } = this.props;
    const {
      testimonials: allTestimonials,
    } = testimonial;
    const testimonials = showAll
      ? allTestimonials
      : _.take(allTestimonials, 8);

    if (testimonial.isLoading || metadata.isLoading) {
      return <div>{i18n.t('loading')}</div>;
    }
    if (_.isEmpty(testimonials)) {
      return null;
    }

    return (
      <PublicTestimonialSection
        showAll={showAll}
        testimonials={testimonials}
        medicalGroups={metadata.data.medicalGroup}
        specialties={metadata.data.specialty}
        router={router}
        getPhotoDownloadURLCallback={this.getPhotoDownloadURLCallback}
      />
    );
  }
}

export default connectActionsAndReducers(PublicTestimonialContainer);



// WEBPACK FOOTER //
// ./src/containers/testimonial/PublicTestimonialContainer.js